<template>
    <div class="container" style="margin-top:-80px;background-color: #B62D2E">
        <div class="container-bottom" :style="{'background-color':$route.path=='/home'?'':'#B62D2E'}">
            <div class="container-bottom-text">
              <span>
                <span class="cursor-pointer" @click="onContact">{{ $t('other.contact') }}</span>
                <el-divider direction="vertical"></el-divider>
                <span class="cursor-pointer" @click="onSitemap">{{ $t('other.sitemap') }}</span>
                <el-divider direction="vertical"></el-divider>
                <span class="cursor-pointer" @click="onRefund">{{ $t('other.refund') }}</span>
                <el-divider direction="vertical"></el-divider>
                <span class="cursor-pointer" @click="onPrivacy">{{ $t('other.privacy') }}</span>
                <el-divider direction="vertical"></el-divider>
                <span class="cursor-pointer" @click="onDisclaimer">{{ $t('other.disclaimer') }}</span>
              </span>
              <br>
              <span>© 2025 {{ $t('other.version') }}</span>
            </div>
        </div>

        <div class="container-bottom-phone">
            <div class="container-bottom-text">
              <span class="cursor-pointer" @click="onContact">{{ $t('other.contact') }}</span>
              <el-divider direction="vertical"></el-divider>
              <span class="cursor-pointer" @click="onSitemap">{{ $t('other.sitemap') }}</span>
              <el-divider direction="vertical"></el-divider>
              <span class="cursor-pointer" @click="onRefund">{{ $t('other.refund') }}</span>
              <el-divider direction="vertical"></el-divider>
              <span class="cursor-pointer" @click="onPrivacy">{{ $t('other.privacy') }}</span>
              <el-divider direction="vertical"></el-divider>
              <span class="cursor-pointer" @click="onDisclaimer">{{ $t('other.disclaimer') }}</span>
              <br>
              <span style="margin-top:2rem;text-align:center;line-height: 1.5">© 2025 {{ $t('other.version') }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    methods: {
        onContact(){
            this.$router.push({ name: "contact" });
        },
        onSitemap(){
            this.$router.push({ name: "sitemap" });
        },
        onRefund(){
            this.$router.push({ name: "refund" });
        },
        onPrivacy(){
            this.$router.push({ name: "privacy" });
        },
        onDisclaimer(){
            this.$router.push({ name: "disclaimer" });
        },
    },
};
</script>

<style lang="scss"  scoped>
.container-bottom {
    display: flex;
    //position: absolute;
    //bottom: 0;
    width: 100%;
    //background-color: #B62D2E;
    height: 5.5rem;
    justify-content: center;
    align-items: center;
}
.container-bottom-text{
    //display: flex;
    flex-direction: column;
    align-items: center;
    //position:absolute;
    bottom: 1.375rem;
    color: white;
    line-height: 1.375rem;
    padding-left: 2rem;
    padding-right: 2rem;
}
.container-bottom-phone{
    display: none;
}

@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
    .container-bottom-phone{
        display: flex;
        //position: absolute;
        //bottom: 0;
        width: 100%;
        background-color: #B62D2E;
        height: 5.5rem;
        justify-content: center;
        align-items: center;
    }
    .container-bottom{
        display: none;
    }
    .cursor-pointer{
        margin: 0.5rem 0;
    }
}
</style>